import { render, staticRenderFns } from "./centSelect.vue?vue&type=template&id=be1907ca&scoped=true"
import script from "./centSelect.vue?vue&type=script&lang=js"
export * from "./centSelect.vue?vue&type=script&lang=js"
import style0 from "./centSelect.vue?vue&type=style&index=0&id=be1907ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1907ca",
  null
  
)

export default component.exports